// 2020-06-27export { MessageInfoComponent } from './message-info.component';